'use strict';

var poser = require('poser');
var Dominus = poser.Array();

module.exports = Dominus;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dominus/src/Dominus.ctor.js
 ** module id = 31
 ** module chunks = 0
 **/